export const calculateRoundedPercentage = (value: number, pricePerUom: number) => {
  const percentage = (value / pricePerUom) * 100
  const wholeNumber = String(percentage)?.split('.')[0]
  const decimalPoints = String(percentage)?.split('.')[1]
  const combinePercentage = `${wholeNumber}.${decimalPoints?.slice(0, 3)}`
  let roundedPercentage = percentage

  if (decimalPoints?.length > 2)
    roundedPercentage = Math.ceil(Number(combinePercentage) * 100) / 100

  return roundedPercentage
}
